module.exports = __webpack_public_path__ + "static/media/RICS.5a8c170b.png";